import React from "react";

import {
  Button,
  Container,
  ImgBlock,
  InfoBlock,
  InfoItem,
  Text,
  Title,
} from "./styles"

type TOutcomeItem = {
  title: string,
  text: string,
};

type TOutcomeSection = {
  data: TOutcomeItem[],
  backgroundImage: string,
  onButtonClick?: () => void,
};

export const OutcomeSection: React.FC<TOutcomeSection> = ({
  data,
  backgroundImage,
  onButtonClick,
}) => {
  const showButton = Boolean(onButtonClick);

  return (
    <Container>
      <ImgBlock bgImage={backgroundImage}>
        {showButton && (
          <Button onClick={onButtonClick}>Программа обучения</Button>
        )}
      </ImgBlock>
      <InfoBlock>
        {data.map((item, i) => (
          <InfoItem key={i}>
            <Title>{item.title}</Title>
            <Text>{item.text}</Text>
          </InfoItem>
        ))}
      </InfoBlock>
    </Container>
  )
}
